import React, { ReactNode } from 'react';
import styles from './GetStarted.module.scss';
import classNames from 'classnames';

type Props = {
  header: ReactNode;
  description: ReactNode;
};

const GetStartedHeadings = ({ header, description }: Props) => {
  return (
    <div className={classNames(styles.titleContainer)}>
      <h1 className={styles.title}>{header}</h1>
      <div className={styles.subtitle}>{description}</div>
    </div>
  );
};

export default GetStartedHeadings;
